import { render, staticRenderFns } from "./videolist.vue?vue&type=template&id=8e4dd026&scoped=true&"
import script from "./videolist.vue?vue&type=script&lang=js&"
export * from "./videolist.vue?vue&type=script&lang=js&"
import style0 from "./videolist.vue?vue&type=style&index=0&id=8e4dd026&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4dd026",
  null
  
)

export default component.exports